import reducer from './reducers';

export { default as productsSelectors } from './selectors';
export { default as productsOperations } from './operations';
export { default as productsTypes } from './types';

export default reducer;
